export enum VisibilityTypeEnum {
	PUBLIC = 'PUBLIC',
	PRIVATE = 'PRIVATE',
}
export enum VisibilityLabelsTypeEnum {
	PUBLIC = 'Publique',
	PRIVATE = 'Privée',
}
